import { Outlet, useLocation } from 'react-router';
import { Typography } from '@mui/material';
import { PageContainer } from '../../../../components/Layout/PageContainer';
import { getRouteTitle, ROUTES } from '../../../../constants/RouteNameMapping';
import { kpisRequestsListStateJ } from '../../../../services/state/KPI/KPIRequestsStateJ';
import { KPIRequestsTabs } from './KPIRequestsTabs';
import KPIResponsesTabs from './KPIResponsesTabs';
import { useAtomValue } from 'jotai';

export default function KPIRequests() {
  useAtomValue(kpisRequestsListStateJ);

  return (
    <PageContainer>
      <Typography variant='h4'>{getRouteTitle(ROUTES.KPI_REQUESTS)}</Typography>
      <KPIRequestsTabs />
      <Outlet />
    </PageContainer>
  );
}

export function KPIResponses() {
  useAtomValue(kpisRequestsListStateJ);
  const isFullPageView = useIsFullPageView();

  return (
    <PageContainer>
      {!isFullPageView && (
        <>
          <Typography variant='h4'>{getRouteTitle(ROUTES.KPI_RESPONSES)}</Typography>
          <KPIResponsesTabs />
        </>
      )}
      <Outlet />
    </PageContainer>
  );
}

function useIsFullPageView() {
  const { pathname } = useLocation();
  return (
    pathname ===
    `/${ROUTES.KPI}/${ROUTES.KPI_RESPONSES}/${ROUTES.KPI_RESPONSES_ACCEPTED}/${ROUTES.KPI_RESPONSES_ANALYSIS}`
  );
}
